module finadai.app.customers.timeline {
  export var NAME = 'finadai.app.customers.timeline';
  function CustomerTimelineController(customer: ng.IHttpPromiseCallbackArg<models.http.responses.Record<models.Customer>>, $scope) {
    var _customer = customer.data.data;
    _customer.all_logs = [];
    $scope.filters = [
      { name: "Direcciones", selected: true, type: "App\\Domain\\Identity\\Location"}, 
      { name: "Teléfonos", selected: true, type: "App\\Domain\\Identity\\Phone" }, 
      { name: "Emails", selected: true, type: "App\\Domain\\Identity\\Email" } 
    ]
    angular.forEach(customer.data.data.locations, item => { _customer.all_logs = _customer.all_logs.concat(item.logs) });
    angular.forEach(customer.data.data.phones, item => { _customer.all_logs = _customer.all_logs.concat(item.logs) });
    angular.forEach(customer.data.data.emails, item => { _customer.all_logs = _customer.all_logs.concat(item.logs) });
    $scope.customer = _customer;
    $scope.displayFields = (value) => {
      var output = '<ul>';
      angular.forEach(value, (value, key) => { output+= '<li>' + key + ": " + value + '</li>'; });
      output+= '</ul>';
      return output
    }
    $scope.filterLogs = (logs: Array<models.Log>) => {
      var selectedFilters = $scope.filters.filter(x => x.selected).map(x => x.type);
      return logs.filter(x => selectedFilters.indexOf(x.owner_type) >= 0 );
    }
  }
  export function run(){
    var timeline = angular.module(NAME, []);
    timeline.controller('CustomerTimelineController', CustomerTimelineController)
  }
} finadai.app.customers.timeline.run();